export default __webpack_public_path__ + "static/media/art-wall.974133df.jpg";